<footer class="bg-white">
  <div class="container mx-auto px-4 py-12">
    <!-- Logo and Description -->
    <div class="mb-8">
      <div class="flex items-center mb-4">
        <img
          src="assets/images/logo/qootk.png"
          alt="Qootaq Logo"
          class="h-8 w-auto"
        />
      </div>
      <p class="text-gray-600 max-w-md">
        {{ "footer.description" | translate }}
      </p>
      <!-- Social Media Links -->
      <div class="flex space-x-4 mt-4">
        <a
          href="https://www.instagram.com/qootk.om"
          class="text-gray-600 hover:text-primary"
        >
          <i class="fab fa-instagram"></i>
        </a>
      </div>
    </div>

    <!-- Navigation Grid -->
    <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
      <!-- Navigation -->
      <div>
        <h3 class="font-semibold text-gray-900 mb-4">
          {{ "footer.navigation.title" | translate }}
        </h3>
        <ul class="space-y-2">
          <li>
            <a routerLink="/" class="text-gray-600 hover:text-primary">{{
              "footer.navigation.items.home" | translate
            }}</a>
          </li>
          <li>
            <a
              routerLink="/features"
              class="text-gray-600 hover:text-primary"
              >{{ "footer.navigation.items.features" | translate }}</a
            >
          </li>
          <li>
            <a routerLink="/pricing" class="text-gray-600 hover:text-primary">{{
              "footer.navigation.items.pricing" | translate
            }}</a>
          </li>
          <li>
            <a
              routerLink="/testimonials"
              class="text-gray-600 hover:text-primary"
              >{{ "footer.navigation.items.testimonials" | translate }}</a
            >
          </li>
          <li>
            <a
              routerLink="/contact-us"
              class="text-gray-600 hover:text-primary"
              >{{ "footer.navigation.items.contact" | translate }}</a
            >
          </li>
        </ul>
      </div>

      <!-- Legal -->
      <div>
        <h3 class="font-semibold text-gray-900 mb-4">
          {{ "footer.legal.title" | translate }}
        </h3>
        <ul class="space-y-2">
          <li>
            <a
              [routerLink]="['/terms-of-service']"
              class="text-gray-600 hover:text-primary"
              >{{ "footer.legal.items.terms" | translate }}</a
            >
          </li>
          <li>
            <a
              [routerLink]="['/privacy-policy']"
              class="text-gray-600 hover:text-primary"
              >{{ "footer.legal.items.privacy" | translate }}</a
            >
          </li>
          <li>
            <a
              [routerLink]="['/license']"
              class="text-gray-600 hover:text-primary"
              >{{ "footer.legal.items.license" | translate }}</a
            >
          </li>
        </ul>
      </div>
    </div>

    <!-- Copyright -->
    <div class="mt-12 pt-8 border-t border-gray-200">
      <p class="text-gray-600 text-sm">
        {{ "footer.copyright" | translate : { currentYear: currentYear } }}
      </p>
    </div>
  </div>
</footer>
